import axios from '../axios';
import { getApiPath } from '../utils';

const baseUrl = getApiPath();

// excel 模板下载: 有业务类型的
const downloadBusinessTemplate = (templateNumber, templateVersion, templateName) => {
  return axios({
    url: `${baseUrl}/BaseExcelService/downloadTemplate?templateNumber=${templateNumber}&tempVersion=${templateVersion}&templateName=${templateName}`,
    method: 'get',
    responseType: 'blob', // 表明返回服务器返回的数据类型
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

// excel 模板下载: 无业务类型
const downloadTemplate = (templateType, templateName) => {
  return axios({
    url: `${baseUrl}/template/TemplateBusinessPageService/downloadTemplate?templateType=${templateType}&templateName=${templateName}`,
    method: 'get',
    responseType: 'blob', // 表明返回服务器返回的数据类型
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
/**
 *  excel 模板导入
 * @param {priceSource} 订单导入价格的来源
 * @param {*} url
 */
const importExcel = (params, url) => {
  return axios({
    url: `${baseUrl}/${url}/importExcel?filePath=${params.filePath}&toElsAccount=${params.toElsAccount}&priceSource=${params.priceSource}`,
    method: 'get'
  });
};

export const DownloadAndImportService = {
  downloadBusinessTemplate,
  downloadTemplate,
  importExcel
};
